import React, { CSSProperties, useEffect, useState } from 'react';
import { MdDelete } from 'react-icons/md';

import { useTranslations } from 'next-intl';

import { BasicResource } from '../../types/types';

interface PropTypes {
  style?: CSSProperties;
  data: BasicResource;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  onDelete?: React.MouseEventHandler<HTMLElement> | undefined;
  className?: string;
}

function ResourceItem({ data, onClick, onDelete, className }: PropTypes) {
  const t = useTranslations();
  const [renderOnClient, setRenderOnClient] = useState(false);
  const [loadFallback, setLoadFallback] = useState(false);

  useEffect(() => {
    setRenderOnClient(true);
  }, []);

  return (
    <div
      className={`flex flex-col items-center relative title-item ${className}`}
    >
      {renderOnClient && (
        <div className="w-full h-auto bg-gray-400 rounded-md cursor-pointer img-wrapper">
          <img
            className="hover:opacity-[0.4] w-[300px] h-[150px] md:w-[140px] md:h-[210px] transition-all duration-200 rounded-md"
            onClick={onClick}
            alt={
              data.type === 'movie'
                ? t('images_alts.movie_poster', { title: data.title })
                : t('images_alts.tv_poster', { title: data.title })
            }
            src={
              loadFallback || !data.poster?.file_path
                ? '/assets/app/poster-fallback.jpg'
                : `https://cdn-proxy.trakio.app/t/p/w185${data?.poster?.file_path}`
            }
            srcSet={
              data?.poster?.file_path &&
              `
              https://cdn-proxy.trakio.app/t/p/w92${data?.poster?.file_path} 92w,
              https://cdn-proxy.trakio.app/t/p/w185${data?.poster?.file_path} 185w
            `
            }
            onError={() => {
              setLoadFallback(true);
            }}
            sizes="
              (min-width: 300px) 92px
              (min-width: 768px) 185px"
          />

          {onDelete && (
            <button
              className="flex justify-center items-center absolute top-2 right-2 w-[30px] h-[30px] rounded-full transition-all duration-200 bg-white text-black hover:bg-gray-200"
              onClick={e => {
                e.preventDefault();
                onDelete(e);
              }}
            >
              <MdDelete size={14} />
            </button>
          )}
        </div>
      )}

      {!renderOnClient && (
        <img
          className="hover:opacity-[0.4] w-[300px] h-[150px] md:w-[140px] md:h-[210px] transition-all duration-200 rounded-md"
          alt={
            data.type === 'movie'
              ? t('images_alts.movie_poster', { title: data.title })
              : t('images_alts.tv_poster', { title: data.title })
          }
          src={
            data?.poster?.file_path
              ? `https://cdn-proxy.trakio.app/t/p/w185${data?.poster?.file_path}`
              : '/assets/app/poster-fallback.jpg'
          }
          srcSet={
            data?.poster?.file_path &&
            `
            https://cdn-proxy.trakio.app/t/p/w92${data?.poster?.file_path} 92w,
            https://cdn-proxy.trakio.app/t/p/w185${data?.poster?.file_path} 185w
          `
          }
          sizes="
            (min-width: 300px) 92px
            (min-width: 768px) 185px"
        />
      )}
      <span
        className="text-white font-bold text-center cursor-pointer w-full px-2 line-clamp-2 mt-1"
        onClick={onClick}
      >
        {data.title}
      </span>
    </div>
  );
}

export default React.memo(ResourceItem);
